import { makeStyles } from '~/UIKit/Style';
import { FADED_GREY, WHITE } from '~/Constants/Colors.constants';

export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: `${FADED_GREY}`,
    padding: '200px 50px',
    fontWeight: '900',
    height: '100vh',
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  innerBox: {
    backgroundColor: `${WHITE}`,
    padding: '50px',
    margin: '0 auto',
    borderRadius: '20px',
    width: 500,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  text: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  textPaddingBottom: {
    paddingBottom: 15,
  },
  buttons: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'space-around',
  },
  acceptButtonText: {
    color: `${WHITE}`,
  },
}));
